export enum InfoBoxBgColor {
  //0x000000,
  blue = 0xC7DCED,
  //0x50E3C2,
  green = 0xB8E986,
  yellow = 0xFDECB7,
  orange = 0xFBB862,
  //0xD0021B,
  //0xBD10E0,
  //0x9013FE,
  //0x417505,
  //0x223344,
  pink = 0xFC99C4
}